import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaCardComponent } from '@global-front-components/ui/card';
import { ColumnasTabla } from '../../../ui/model/tabla-seguros.model';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';
import { RegistroAsegurado } from './model/tabla-asegurados.model';
import { DateUtilsService } from '../../../comun/services/util/date-utils.service';
import { CaTablaSegurosComponent } from '../../../ui/components/tabla-seguros/tabla-seguros.component';
import { RiesgoSalud } from '../../../comun/model/salud.model';

@Component({
	selector: 'app-datos-asegurados',
	standalone: true,
	imports: [
		CommonModule,
		CaCardComponent,
		TranslateModule,
		CaTablaSegurosComponent
	],
	templateUrl: './datos-asegurados.component.html',
	styleUrls: ['./datos-asegurados.component.scss']
})
export class DatosAseguradosComponent implements OnInit {
	@Input() riesgos: RiesgoSalud[];
	public registros: RegistroAsegurado[];
	public columnas: ColumnasTabla[] = [];

	constructor(
		private translateService: TranslateService,
		private dateUtil: DateUtilsService
	) {}

	ngOnInit(): void {
		this.getTraducciones();
		if (this.riesgos?.length) {
			this.registros = this.convertirPersonasAsegurados(this.riesgos);
		}
	}

	private getTraducciones(): void {
		forkJoin([
			this.translateService.get('DATOS_SOLICITUD.ASEGURADOS.TABLA_ASEGURADOS.NOMBRE'),
			this.translateService.get('DATOS_SOLICITUD.ASEGURADOS.TABLA_ASEGURADOS.APELLIDOS'),
			this.translateService.get('DATOS_SOLICITUD.ASEGURADOS.TABLA_ASEGURADOS.DOCUMENTO'),
			this.translateService.get('DATOS_SOLICITUD.ASEGURADOS.TABLA_ASEGURADOS.FECHA_NACIMIENTO'),
			this.translateService.get('DATOS_SOLICITUD.ASEGURADOS.TABLA_ASEGURADOS.SEXO'),
			this.translateService.get('DATOS_SOLICITUD.ASEGURADOS.TABLA_ASEGURADOS.PARENTESCO'),
			this.translateService.get('DATOS_SOLICITUD.ASEGURADOS.TABLA_ASEGURADOS.FECHA_ALTA'),
			this.translateService.get('DATOS_SOLICITUD.ASEGURADOS.TABLA_ASEGURADOS.FECHA_BAJA'),
			this.translateService.get('DATOS_SOLICITUD.ASEGURADOS.TABLA_ASEGURADOS.NUM_TARJETA'),
			this.translateService.get('DATOS_SOLICITUD.ASEGURADOS.TABLA_ASEGURADOS.TLF_MOVIL'),
			this.translateService.get('DATOS_SOLICITUD.ASEGURADOS.TABLA_ASEGURADOS.EMAIL')
		]).subscribe(translations => {
			this.columnas = [
				{ id: 0, field: 'nombre', value: translations[0] },
				{ id: 1, field: 'apellidos', value: translations[1] },
				{ id: 2, field: 'documento', value: translations[2] },
				{ id: 3, field: 'fechaNacimiento', value: translations[3] },
				{ id: 4, field: 'sexo', value: translations[4] },
				{ id: 5, field: 'parentesco', value: translations[5] },
				{ id: 6, field: 'fechaAlta', value: translations[6] },
				{ id: 7, field: 'fechaBaja', value: translations[7] },
				{ id: 8, field: 'numeroTarjeta', value: translations[8] },
				{ id: 9, field: 'tlfMovil', value: translations[9] },
				{ id: 10, field: 'email', value: translations[10] },
			];
		});
	}

	private convertirPersonasAsegurados(riesgos: RiesgoSalud[]): RegistroAsegurado[] {
		return riesgos
			.filter(riesgo => riesgo.asegurado) // Ensure asegurado exists
			.map(riesgo => {
				const cliente = riesgo.asegurado;
				return {
					nombre: cliente.nombre ?? cliente.razonSocial ?? '',
					apellidos: [cliente.apellido1, cliente.apellido2].filter(Boolean).join(' ') || '',
					documento: cliente.documento ?? '',
					fechaNacimiento: this.dateUtil.formatearFecha(cliente.fechaNacimiento),
					sexo: cliente.codigoSexo ?? '',
					parentesco: riesgo.codigoParentesco ?? '', // Use from riesgo
					fechaAlta: this.dateUtil.formatearFecha(cliente.fechaAlta),
					fechaBaja: this.dateUtil.formatearFecha(cliente.fechaBaja),
					numeroTarjeta: cliente.numeroTarjeta ?? '',
					email: cliente.datosContacto?.email?.direccion ?? '',
					tlfMovil: cliente.datosContacto?.telefonoMovil?.numero ?? '',
				};
			});
	}
	

}
